import { useEffect } from "react";

import PropTypes from "prop-types";

import focusElementRefKeys from "@/view/constants/focusElementRefKeys";
import videoPlayerEvents from "@/view/constants/videoPlayerEvents";
import getEventPropertiesContentType from "@/view/utils/getEventPropertiesContentType";
import useFocusManager from "@/view/utils/useFocusManager";
import useVideoEventBus from "@/view/utils/useVideoEventBus";
import NewselaHomeLink from "../Banner/NewselaHomeLink";
import BannerHeaderText from "../Banner/BannerHeaderText";
import Banner from "../Banner";
import { rootCss } from "./PresentModeBanner.style";

const { VIEW_PAGE_EVENT } = videoPlayerEvents;

const propTypes = {
  bannerRef: PropTypes.object,
  contentId: PropTypes.string,
  contentType: PropTypes.string,
  handleToggleBannerMode: PropTypes.func,
  setIsPresentModeActive: PropTypes.func,
};

const logoPropTypes = {
  ref: PropTypes.node,
};

const Logo = () => {
  const { setFocusManagerRef } = useFocusManager();

  return (
    <NewselaHomeLink
      ref={(ref) =>
        setFocusManagerRef(ref, focusElementRefKeys.bannerHomeButton)
      }
    />
  );
};

const PresentModeBanner = ({
  bannerRef,
  contentId,
  contentType,
  handleToggleBannerMode,
  setIsPresentModeActive,
}) => {
  const { sendVideoPlayerEvent } = useVideoEventBus();
  const { focusElement } = useFocusManager();

  const closeButtonAriaLabel = "Close Present mode";
  const bannerText = "Presenting";

  const eventProperties = {
    objectType: "Content",
    actionName: "Page View",
    streamProperties: {
      content_type: getEventPropertiesContentType(contentType),
      description: "Close Present mode",
      content_id: contentId,
    },
  };

  useEffect(() => {
    focusElement(focusElementRefKeys.bannerHomeButton);
  }, []);

  const handleClose = () => {
    handleToggleBannerMode();
    setIsPresentModeActive(false);
    sendVideoPlayerEvent(VIEW_PAGE_EVENT.PRESENT_MODE_ACTIVE, {
      isPresentModeActive: false,
      isPresentModeActiveWithoutQuiz: false,
    });
  };

  return (
    <Banner
      __cssFor={{ rootCss }}
      bannerRef={bannerRef}
      bannerAriaLabel={bannerText}
      closeButtonAriaLabel={closeButtonAriaLabel}
      contentId={contentId}
      contentType={contentType}
      eventProperties={eventProperties}
      handleToggleBannerMode={handleToggleBannerMode}
      logo={<Logo />}
      onClose={handleClose}
    >
      <BannerHeaderText title={bannerText.toUpperCase()} />
    </Banner>
  );
};

Logo.propTypes = logoPropTypes;
PresentModeBanner.propTypes = propTypes;

export default PresentModeBanner;
